import { Google, Pixall } from '../analytics/index.js';
import { getInventoryOwnerById } from '../utilities/index.js';
import { listingTypeUtils } from '../transformers/pixall/index.js';

/**
 * @summary Sends Snap 360 - Click
 */
export function snap360Click(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    dataLayer,
    state,
    data = {}
  } = metadata;
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const {
    specifications,
    listingType
  } = inventory;
  const fuelEconomy = specifications?.mpg?.value;
  const clickType = state?.query?.clickType || '';
  const eventLabel = 'cta::snap-360';
  Google.sendClickEvent({
    eventElement: `vdp_${listingType.toLowerCase()}`,
    eventResult: eventLabel
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'vehicle',
    label: eventLabel,
    listingType: listingTypeUtils.convertClickTypeToListingType(clickType),
    vehicleType: listingType.toUpperCase(),
    pageType: 'vdp',
    fuelEconomy,
    ...data,
    inventory
  }, dataLayer, option);
  return {};
}

/**
 * @summary Sends Snap VI 360 - Click
 */
export function vi360Click(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    dataLayer,
    state,
    data = {}
  } = metadata;
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const eventLabel = 'cta::vi360';
  const feature = 'VI360';
  const brandName = dataLayer.brand?.toUpperCase();
  Pixall.sendClickEvent({
    assistChannel: brandName === 'ATC' ? 'Autotrader' : brandName,
    assistProduct: dataLayer.page?.pageName.toUpperCase(),
    assistSubchannel: feature,
    feature,
    eventSource: 'vehicle',
    label: eventLabel,
    pixallData: {
      clickTypeToListingType: true
    },
    ...data,
    inventory
  }, dataLayer, option);
  return {};
}
export default {
  snap360Click,
  vi360Click
};